import { editToolHandler } from './editToolHandler';
import { navigationToolHandler } from './navigationToolHandler.utils';
import { openLoanSectionToolHandler } from './openLoanSectionToolHandler';
import { workflowToolHandler } from './workflowToolHandler';

const toolRegistry = {
  navigate_to_tab: navigationToolHandler,
  navigate_to_subtab: navigationToolHandler,
  navigate_to_borrower: navigationToolHandler,
  navigate_to_financial_view: navigationToolHandler,
  navigate_to_entity: navigationToolHandler,
  navigate_to_field: navigationToolHandler,

  open_loan_section: openLoanSectionToolHandler,

  edit_field: editToolHandler,
  edit_fields: editToolHandler,

  create_task: workflowToolHandler,
  add_condition: workflowToolHandler,
  request_document: workflowToolHandler,
  update_loan_status: workflowToolHandler,
};

export const getToolHandler = toolName => {
  if (toolRegistry[toolName]) {
    return toolRegistry[toolName];
  }

  if (toolName.startsWith('navigate_to_')) {
    return navigationToolHandler;
  }

  if (toolName.startsWith('edit_') || toolName.startsWith('update_')) {
    return editToolHandler;
  }

  if (toolName.startsWith('create_') || toolName.startsWith('add_')) {
    return workflowToolHandler;
  }

  return null;
};

export const isToolSupported = toolName => !!getToolHandler(toolName);

export default toolRegistry;
